"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiToken = exports.username = void 0;
const axios_1 = __importStar(require("axios"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const nanoid_1 = require("nanoid");
const FIRST_NAME = 'John';
const LAST_NAME = 'Smith';
async function getApiToken() {
    var _a;
    const credentials = getCredentials();
    exports.username = credentials.username;
    const password = credentials.password;
    try {
        const loginResponse = await login(exports.username, password);
        return loginResponse.data.access_token;
    }
    catch (error) {
        if (error instanceof axios_1.AxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            const registerResponse = await register(exports.username, password, FIRST_NAME, LAST_NAME);
            return registerResponse.data.access_token;
        }
        else {
            throw error;
        }
    }
}
exports.getApiToken = getApiToken;
function getCredentials() {
    let username = js_cookie_1.default.get('username');
    let password = js_cookie_1.default.get('password');
    if (!username || !password) {
        username = (0, nanoid_1.nanoid)();
        password = (0, nanoid_1.nanoid)();
        js_cookie_1.default.set('username', username);
        js_cookie_1.default.set('password', password);
    }
    return { username, password };
}
async function register(username, password, firstName, lastName) {
    return await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/auth/register`, {
        username,
        password,
        firstName,
        lastName,
    });
}
async function login(username, password) {
    return await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/auth/login`, {
        username,
        password,
    });
}
